---
date: 2022-01-02
title: Preview your edit with OsmInEdit
---

When editing indoor area with [OsmInEdit](https://osminedit.pavie.info/#19/48.64075/-123.43078/0), you can now directly preview your changes using indoor=. Use the preview button once your start editing.
